/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQueryBrowser = (props) => (_jsxs("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "ndl-icon-svg" }, props, { children: [_jsx("path", { d: "M18.2771 18H13.187C12.2248 18 11.4489 17.2218 11.4489 16.2568C11.4489 15.2919 12.2248 14.5137 13.187 14.5137H18.2616C19.2238 14.5137 19.9997 15.2919 19.9997 16.2568C20.0152 17.2218 19.2238 18 18.2771 18Z", fill: "currentColor" }), _jsx("path", { d: "M5.83121 17.4861C5.38117 17.4861 4.94664 17.3149 4.60523 16.9725C3.92241 16.2877 3.92241 15.1827 4.60523 14.5134L7.32101 11.7898L4.51212 8.9727C3.82929 8.28789 3.82929 7.18286 4.51212 6.51361C5.19494 5.8288 6.29677 5.8288 6.96408 6.51361L10.999 10.5602C11.6818 11.245 11.6818 12.3501 10.999 13.0193L7.05719 16.9725C6.71578 17.3149 6.28126 17.4861 5.83121 17.4861Z", fill: "currentColor" })] })));
export default SvgQueryBrowser;
//# sourceMappingURL=QueryBrowser.js.map